/* gf-header — dropdown + drawer behaviour.
   The markup works without JS (native <details>); this only adds the
   niceties native details cannot do: close on outside click, close on
   Escape, one dropdown open at a time, and close the drawer when the
   viewport grows past the burger breakpoint. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.gfHeaderReady === 'true') return;
    root.dataset.gfHeaderReady = 'true';

    var dropdowns = Array.prototype.slice.call(root.querySelectorAll('.gf-header__dd'));
    var drawer = root.querySelector('[data-gf-drawer]');
    var all = dropdowns.concat(drawer ? [drawer] : []);

    function closeAll(except) {
      all.forEach(function (d) {
        if (d !== except) d.removeAttribute('open');
      });
    }

    all.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.hasAttribute('open')) closeAll(d);
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAll(null);
    });

    // Keep focus from tabbing out of the open drawer and landing on page
    // controls the opaque panel covers (WCAG 2.2 SC 2.4.11).
    if (drawer) {
      drawer.addEventListener('focusout', function (event) {
        var next = event.relatedTarget;
        if (!next) return;                  // focus left the document — keep it open
        if (drawer.contains(next)) return;  // still inside (incl. the burger summary)
        drawer.removeAttribute('open');
      });
    }

    // Bound to the document, not the header: once focus has escaped the panel
    // a header-scoped listener would never see the Escape key.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = root.querySelector('.gf-header__dd[open], [data-gf-drawer][open]');
      if (!open) return;
      var wasInside = open.contains(document.activeElement);
      open.removeAttribute('open');
      if (!wasInside) return;               // don't yank focus out of an unrelated widget
      var summary = open.querySelector('summary');
      if (summary && summary.focus) summary.focus();
    });

    if (window.matchMedia) {
      // 1240px is where the CSS swaps the burger for the desktop nav row.
      var wide = window.matchMedia('(min-width: 1240px)');
      var onChange = function (event) {
        if (event.matches && drawer) drawer.removeAttribute('open');
        if (!event.matches) dropdowns.forEach(function (d) { d.removeAttribute('open'); });
      };
      if (wide.addEventListener) wide.addEventListener('change', onChange);
      else if (wide.addListener) wide.addListener(onChange);
    }
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-gf="header"]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
